// extracted by mini-css-extract-plugin
module.exports = {"page":"EventList_page__2AI07","mainTable":"EventList_mainTable__2yLTa"};